import React from 'react'
import PageHeader from '../components/shared/pageHeader/PageHeader'
import LeadsHeader from '../components/leadsViewCreate/LeadsViewHeader'
import LeadssTable from '../components/leads/StudentsEdit'
import Footer from '../components/shared/Footer'

const DefinitionsList = () => {
    return (
        <>
            <PageHeader>
                <LeadsHeader />
            </PageHeader>
            <div className='main-content'>
                <div className='row'>
                    <LeadssTable />
                </div>
            </div>
            
        </>
    )
}

export default DefinitionsList